import {createApi} from '@reduxjs/toolkit/query/react';

import {promptBridgeBaseQuery} from '../baseQuery/promptBridgeBaseQuery';
import {PROMPT_BRIDGE_ASSISTANT_AVAILABILITY_TAG} from '../constants/PROMPT_BRIDGE_ASSISTANT_AVAILABILITY_TAG';

export const promptBridgeApi = createApi({
  baseQuery: promptBridgeBaseQuery,
  reducerPath: 'rtk_promptBridgeApi',
  tagTypes: [
    'PromptBridgeMessage',
    'PromptBridgePrompt',
    'PromptBridgeUsage',
    'PromptBridgeHealthCheck',
    'PromptBridgeAdmin',
    'PromptBridgeOpenAI',
    'PromptBridgeStorageService',
    'PromptBridgeNissanPart',
    'PromptBridgeHondaPart',
    'PromptBridgeHondaRecall',
    PROMPT_BRIDGE_ASSISTANT_AVAILABILITY_TAG,
  ],
  endpoints: () => ({}),
});
